import { MDCDrawer } from '@material/drawer'

export default {
  setup() {
    this.drawer = new MDCDrawer.attachTo(this.el)
  },
  destroy() {
    this.drawer?.destroy()
    this.drawer = null
  },
  mounted() {
    this.setup()

    this.handleEvent('toggle-drawer', ({ drawer_id }) => {
      if (this.el.id === drawer_id && this.drawer) {
        this.drawer.open = !this.drawer.open
      }
    })
  },
  destroyed() {
    this.destroy()
  }
}
